<kendo-timeline [events]="responseActions">
  <ng-template
    kendoTimelineCardHeaderTemplate
    let-event
    let-index="index"
  >
    <span class="k-event-title">{{ event.title }}</span>
  </ng-template>
</kendo-timeline>
